import { InstitutionBaseData, InstitutionId, SelectOptionType } from 'types';

export const parseInstitutionBaseDataIntoSelectOptionType: (
    institutionBaseData: InstitutionBaseData,
) => SelectOptionType<InstitutionId> = (institutionBaseData) => ({
    label: institutionBaseData.name,
    value: institutionBaseData.id,
});
